// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3-V_w","fileBtn":"File_fileBtn__Q6qmR","closeBtn":"File_closeBtn__3IkKQ","fileSelected":"File_fileSelected__Tgb8r","disabled":"File_disabled__2p0zM"};